import { createApp } from 'vue'

import './styles/main.css'
import { createPinia } from 'pinia'
import { registerSW } from 'virtual:pwa-register'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import OpenLayersMap from 'vue3-openlayers'
import 'ol/ol.css'

registerSW({
  immediate: true,
})

const app = createApp(App)
const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(OpenLayersMap)

app.mount('#app')